var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 881,
    viewBox: "0 0 880 881",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 880.8C683.005 880.8 880 683.805 880 440.8C880 197.795 683.005 0.799805 440 0.799805C196.995 0.799805 0 197.795 0 440.8C0 683.805 196.995 880.8 440 880.8Z",
    fill: "#FF1A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M651.3 415C650.9 414.2 650.5 413.5 650 412.8C628.2 379.1 545.7 325.7 440 323.8C334.3 325.7 251.8 379 230 412.8C229.5 413.5 229.1 414.2 228.7 415C222.5 425.1 222 437 222 449.8C222 467.1 225.6 482.9 236.4 494.8C243.9 503.1 254.7 507.8 265.9 507.8H306.1C317.3 507.8 328.1 503.1 335.6 494.8C346.4 482.9 353 467.1 353 449.8C353 444.8 352.4 439.9 351.4 435.2C349.5 425.9 345.6 415.2 340 407.8C359 393.8 409 383 439.5 383C439.7 383 439.8 383 440 383C440.2 383 440.3 383 440.5 383C471 383 521 393.8 540 407.8C534.4 415.2 530.5 426 528.6 435.2C527.6 439.9 527 444.8 527 449.8C527 467.1 533.6 482.9 544.4 494.8C551.9 503.1 562.7 507.8 573.9 507.8H614.1C625.3 507.8 636.1 503.1 643.6 494.8C654.4 482.9 658 467.1 658 449.8C658 437 657.4 425.1 651.3 415Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call-end.13de0155256cfdc07e004e3311a74261.svg";
export { ForwardRef as ReactComponent };